import { createClient } from '@supabase/supabase-js'
import { supabaseConfig } from '../config/credentials'

export const supabase = createClient(
  supabaseConfig.url,
  supabaseConfig.anonKey,
  {
    auth: {
      flowType: 'pkce',
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  }
)

// Database types
export interface UserProfile {
  id: string
  user_id: string
  email: string
  display_name: string | null
  avatar_url: string | null
  dietary_restrictions: string[]
  allergies: string[]
  calorie_target: number | null
  budget_limit: number | null
  preferences: Record<string, any>
  created_at: string
  updated_at: string
}

export interface MealPlan {
  id: string
  user_id: string
  title: string
  description: string | null
  recipes: any[]
  created_at: string
  updated_at: string
  expires_at: string
  is_favorite: boolean
}

export interface Recipe {
  id: string
  title: string
  description: string
  ingredients: any[]
  instructions: string[]
  prep_time: number
  cook_time: number
  servings: number
  nutrition: Record<string, any>
  tags: string[]
  image_url: string | null
  created_at: string
}

export interface GuestSession {
  id: string
  session_token: string
  preferences: Record<string, any>
  meal_history: any[]
  created_at: string
  expires_at: string
}